module.exports = __webpack_public_path__ + "static/media/ao.d31432cd.svg";